module.exports = __webpack_public_path__ + "media/images/icons/chat-left-text-fill-cfa293e183b8bd9a00173c244271c68f.png";